'use strict';
/**
 * @author Maxim Seredkin
 */
export default [function () {
    const getObjectNameField = getObjectField('name');
    const getObjectValueField = getObjectField('value');

    // Math utils
    const log10 = Math.log10 || function (x) {
        var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
        // Check for whole powers of 10,
        // which due to floating point rounding error should be corrected.
        var powerOf10 = Math.round(exponent);
        var isPowerOf10 = x === Math.pow(10, powerOf10);

        return isPowerOf10 ? powerOf10 : exponent;
    };

    return {
        getValue,
        openControlSidebar,
        searchOnYandexMaps,
        removeEmptyFieldsFromObject,

        getObjectField,
        getObjectNameField,
        getObjectValueField,
        mapArray,
        numComparator,
        stringComparator,
        // Math utils
        log10,
    };

    function getValue(path, data) {

        if (!path) {
            return data;
        }

        if (path == '') {
            return data;
        }

        let tmp_s = data,
            tmp_p = path;
        if (path.indexOf('.') > -1) {
            path = path.split('.');
            for (let index in path) {
                if (tmp_s.hasOwnProperty(path[index])) {
                    tmp_p = path[index];
                    if (tmp_s[path[index]] != null && (typeof tmp_s[path[index]] === typeof []) && (index != (path.length - 1))) {
                        tmp_s = tmp_s[path[index]];
                    } else {
                        break;
                    }
                } else {
                    break;
                }
            }
            return tmp_s[tmp_p.trim()];
        } else {
            return data[path.trim()];
        }
    }

    function openControlSidebar(state) {
        let sidebar = $('aside.control-sidebar');
        sidebar.toggleClass('control-sidebar-open', state);
        sidebar.css({
            'height': $('.content-wrapper')
                .height(),
        });
    }

    function searchOnYandexMaps(searchString) {
        let mapLink = `https://yandex.ru/maps/?text=${encodeURIComponent(searchString)}`;
        window.open(mapLink);
    }

    function removeEmptyFieldsFromObject(targetObj) {
        let newObj = {};
        Object.keys(targetObj)
            .filter(key => targetObj[key] !== null && !angular.isUndefined(targetObj[key]))
            .forEach(key => newObj[key] = angular.copy(targetObj[key]));
        return newObj;
    }


    function getObjectField(field) {
        return function (obj) {
            return obj[field];
        };
    }

    function mapArray(array, mapFunc) {
        return array.map(mapFunc);
    }

    function numComparator(a, b) {
        return a - b;
    }

    function stringComparator(a, b) {
        return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    }
}];
